import React from 'react'
import i18next from 'i18next'
import { Button, Form, Row, Col, Card } from 'react-bootstrap'

import hash from 'object-hash'
import isEmail from 'validator/lib/isEmail'
import PlaceSelect from 'src/components/system_wide/places_select'
import { Trans } from 'react-i18next'
import BrandImage from './brand_image'
import ResponsiveTable from '../system_wide/responsive_table'
import ReferenceForm from './reference_form'
import ActionsDropdown from '../system_wide/actions_dropdown'

const { t } = i18next

class BrandForm extends React.Component {
  static defaultProps = {
    brand: {},
    errors: {},
    readonly: false,
    onSave: () => {},
    closeForm: () => {},
    updateErrors: () => {},
  }

  state = {
    id: null,
    name: '',
    business_name: '',
    pec: '',
    email: '',
    piva: '',
    cf: '',
    cuu: '',
    address: '',
    place_id: '',
    enabled: true,
    references: [],
    brand_img: '',

    brand_hash: '',
    current_reference: null,
  }

  initialHash = ''
  tableReferenceRef = null
  constructor(props) {
    super(props)
    this.tableReferenceRef = React.createRef()
    if (props.brand.id) {
      let { id, name, business_name, pec, email, piva, cf, cuu, address, place_id, enabled, references, brand_img } =
        props.brand
      this.state.id = id
      this.state.name = name || ''
      this.state.business_name = business_name || ''
      this.state.pec = pec || ''
      this.state.email = email || ''
      this.state.enabled = enabled ?? false
      this.state.piva = piva || ''
      this.state.cf = cf || ''
      this.state.cuu = cuu || ''
      this.state.address = address || ''
      this.state.place_id = place_id || ''
      this.state.references = references || []
      this.state.brand_img = brand_img || ''
    }

    // eslint-disable-next-line no-unused-vars
    let { brand_hash, current_reference, ...rest } = this.state
    this.initialHash = hash(rest)
    this.state.brand_hash = this.initialHash
  }

  updateHash = () => {
    // eslint-disable-next-line no-unused-vars
    let { brand_hash, current_reference, ...rest } = this.state
    this.setState({ brand_hash: hash(rest) })
  }

  handleChange = ({ target: { name, value } }) => {
    let errors = { ...this.props.errors }
    if (name in errors) {
      delete errors[name]
      this.props.updateErrors({ errors })
    }
    this.setState({ [name]: value }, () => this.updateHash())
  }

  handleChangeCheckbox = ({ target: { name } }) => {
    this.setState({ [name]: !this.state[name] }, () => this.updateHash())
  }

  handledChangePlace = place => {
    let { label, value } = place ?? { label: '', value: '' }
    this.setState({ address: label, place_id: value }, () => this.updateHash())
  }

  handleConfirm = () => {
    // eslint-disable-next-line no-unused-vars
    let { brand_hash, current_reference, ...rest } = this.state
    this.props.onSave(rest)
  }

  isFormValid = () => {
    let { name, business_name } = this.state
    return name && business_name
  }

  isEmailInvalid = prop => {
    let [group, field] = prop.split('.')
    let current_value = group && field ? this.state?.[group]?.[field] ?? '' : this.state?.[group] ?? ''
    return current_value !== '' && !isEmail(current_value)
  }
  handleImageChange = brand_img => {
    this.setState({ brand_img }, () => this.updateHash())
  }
  actions = [
    {
      icon: 'fas fa-edit',
      text: t('actions.edit', 'Modifica'),
      variant: 'outline-warning',
      onClick: rowData => {
        this.setState({ current_reference: rowData })
      },
    },
    {
      icon: 'fas fa-trash-alt',
      text: t('actions.delete', 'Elimina'),
      variant: 'outline-danger',
      onClick: rowData => {
        this.setState({ references: this.state.references.filter(reference => reference.id !== rowData.id) }, () =>
          this.updateHash()
        )
      },
    },
  ]

  actionsRenderer = ({ rowData }) => {
    if (this.props.readonly) return
    return <ActionsDropdown rowData={rowData} actions={this.actions} />
  }

  renderReferenceDetails = rowData => {
    let { reference_name, reference_task, phone, email } = rowData
    return (
      <Card className="shadow-lg mb-4 border-0 rounded-lg">
        <Card.Body className="text-center pb-2 pt-2">
          <h4 className="fw-bold text-primary d-flex align-items-center justify-content-center">{reference_name}</h4>
          <p className="text-muted mb-3">{reference_task}</p>
          {phone && (
            <p className="text-muted mb-0 d-flex align-items-center justify-content-center">
              <i className="fas fa-phone me-2"></i> {phone}
            </p>
          )}

          {email && (
            <p className="text-muted mb-0 d-flex align-items-center justify-content-center">
              <i className="fas fa-envelope me-2"></i> {email}
            </p>
          )}
        </Card.Body>
        {this.props.readonly === false && (
          <Card.Footer className="text-center bg-light pb-3 pt-3">
            <div className="d-flex justify-content-around flex-wrap">
              {this.actions
                .filter(a => {
                  if (typeof a.visible === 'function') {
                    return a.visible(rowData, a)
                  }
                  return a?.visible ?? true
                })
                .map((action, index) => (
                  <Button
                    key={index}
                    variant={action.variant}
                    size="sm"
                    title={action.text}
                    disabled={action?.disabled ?? false}
                    onClick={() => action.onClick(rowData)}>
                    <i className={`${action.icon} me-0`}></i>
                  </Button>
                ))}
            </div>
          </Card.Footer>
        )}
      </Card>
    )
  }

  columns = [
    {
      title: '',
      className: 'd-none d-sm-block text-center',
      style: { width: '6%', minWidth: '3rem' },
      data: this.actionsRenderer,
    },
    {
      title: t('components.brands.reference_name', 'Nome'),
      className: 'd-none d-sm-block flex-fill',
      style: { width: '40%' },
      sortable: false,
      data: 'reference_name',
    },
    {
      title: t('components.brands.reference_task', 'Mansione'),
      className: 'd-none d-sm-block flex-fill',
      style: { width: '24%', minWidth: '7rem' },
      sortable: false,
      data: 'reference_task',
    },
    {
      title: t('components.brands.phone', 'Telefono'),
      className: 'd-none d-sm-block flex-fill',
      style: { width: '15%' },
      sortable: false,
      data: 'phone',
    },
    {
      title: t('components.brands.email', 'Email'),
      className: 'd-none d-sm-block flex-fill',
      style: { width: '15%' },
      sortable: false,
      data: 'email',
    },
    {
      title: t('components.brands.details', 'Dettagli'),
      className: 'd-block d-sm-none flex-fill',
      style: { width: '100%' },
      sortable: false,
      data: ({ rowData }) => {
        return this.renderReferenceDetails(rowData)
      },
    },
  ]

  getColumns = () => {
    return this.columns
  }

  addNewReference = () => {
    let last_id = this.state.references.length > 0 ? this.state.references[this.state.references.length - 1].id + 1 : 1
    this.setState({ current_reference: { id: last_id, reference_name: '', reference_task: '', phone: '', email: '' } })
  }

  onAddReference = reference => {
    this.setState(prevState => {
      const referenceExists = prevState.references.some(ref => ref.id === reference.id)

      const updatedReferences = referenceExists
        ? prevState.references.map(ref => (ref.id === reference.id ? { ...ref, ...reference } : ref))
        : [...prevState.references, reference]

      return { references: updatedReferences, current_reference: null }
    }, this.updateHash)
  }
  componentWillUnmount() {
    this.props.updateErrors({})
  }
  render() {
    let {
      id,
      name,
      business_name,
      email,
      pec,
      address,
      piva,
      cf,
      cuu,
      place_id,
      enabled,
      references = [],
      brand_img,
      current_reference,
    } = this.state
    let { errors, readonly } = this.props
    let place_selected = { label: address, value: place_id }
    return (
      <>
        <div className="flex-fill position-relative overflow-auto">
          <div className="container">
            <Form.Group className="mb-3 mt-2">
              <Form.Label>
                <Trans i18nKey="components.brands.show_brand">Attiva brand</Trans>
              </Form.Label>
              <Form.Check
                type="switch"
                id="enabled"
                name="enabled"
                checked={enabled === true}
                label={t('components.brands.enabled', 'Abilitato')}
                onChange={this.handleChangeCheckbox}
                disabled={readonly}
              />
              <Form.Text id="enabledHelp" muted>
                <Trans i18nKey="components.brands.lock_help">
                  Selezionando questo flag permette la l'assegnazione ad un'utente
                </Trans>
              </Form.Text>
            </Form.Group>
            <Row>
              <Form.Group
                as={Col}
                className="d-flex flex-column align-items-center justify-content-center mb-3 mb-md-0 col-12 col-md-5">
                <BrandImage brand_img={brand_img} id={id} onChange={this.handleImageChange} readonly={readonly} />
              </Form.Group>
              <Col className="col-12 col-md-7">
                <Row>
                  <Form.Group as={Col} className="mb-3 col-12">
                    <Form.Label>
                      <Trans i18nKey="components.brands.name">Nome</Trans>
                    </Form.Label>
                    <span> *</span>
                    <Form.Control
                      name="name"
                      placeholder={t('components.brands.name', 'Nome')}
                      value={name}
                      onChange={this.handleChange}
                      isInvalid={'name' in errors}
                      disabled={readonly}
                    />
                    <Form.Control.Feedback type="invalid">{errors?.name ?? ''}</Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group as={Col} className="mb-3 col-12">
                    <Form.Label>
                      <Trans i18nKey="components.brands.business_name">Ragione sociale</Trans>
                    </Form.Label>
                    <span> *</span>
                    <Form.Control
                      name="business_name"
                      placeholder={t('components.brands.business_name', 'Ragione sociale')}
                      value={business_name ?? ''}
                      onChange={this.handleChange}
                      isInvalid={'business_name' in errors}
                      disabled={readonly}
                    />
                    <Form.Control.Feedback type="invalid">{errors?.business_name ?? ''}</Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group as={Col} className="mb-3 col-12">
                    <Form.Label>
                      <Trans i18nKey="components.brands.address">Indirizzo</Trans>
                    </Form.Label>
                    <PlaceSelect selected={place_selected} onChange={this.handledChangePlace} disabled={readonly} />
                  </Form.Group>
                </Row>
              </Col>
            </Row>

            <Row>
              <Form.Group as={Col} md="6" sm="12" className="mb-3">
                <Form.Label>
                  <Trans i18nKey="components.brands.pec">Pec</Trans>
                </Form.Label>
                <Form.Control
                  name="pec"
                  placeholder={t('components.brands.pec', 'Pec')}
                  value={pec ?? ''}
                  onChange={this.handleChange}
                  isInvalid={this.isEmailInvalid('pec')}
                  disabled={readonly}
                />
                <Form.Control.Feedback type="invalid">
                  <Trans i18nKey="components.brands.invalid_email">Indirizzo e-mail non valido</Trans>
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} md="6" sm="12" className="mb-3">
                <Form.Label>
                  <Trans i18nKey="components.brands.email">Email</Trans>
                </Form.Label>
                <Form.Control
                  name="email"
                  placeholder={t('components.brands.email', 'Email')}
                  value={email ?? ''}
                  onChange={this.handleChange}
                  isInvalid={this.isEmailInvalid('email')}
                  disabled={readonly}
                />
                <Form.Control.Feedback type="invalid">
                  <Trans i18nKey="components.brands.invalid_email">Indirizzo e-mail non valido</Trans>
                </Form.Control.Feedback>
              </Form.Group>
            </Row>

            <Row>
              <Form.Group as={Col} md="4" sm="12" className="mb-3">
                <Form.Label>
                  <Trans i18nKey="components.brands.piva">Partita IVA</Trans>
                </Form.Label>
                <Form.Control
                  name="piva"
                  placeholder={t('components.brands.piva', 'Partita IVA')}
                  value={piva ?? ''}
                  onChange={this.handleChange}
                  disabled={readonly}
                />
              </Form.Group>
              <Form.Group as={Col} md="4" sm="12" className="mb-3">
                <Form.Label>
                  <Trans i18nKey="components.brands.cf">Codice fiscale</Trans>
                </Form.Label>
                <Form.Control
                  name="cf"
                  placeholder={t('components.brands.cf', 'Codice fiscale')}
                  value={cf ?? ''}
                  onChange={this.handleChange}
                  disabled={readonly}
                />
              </Form.Group>
              <Form.Group as={Col} md="4" sm="12" className="mb-3">
                <Form.Label>
                  <Trans i18nKey="components.brands.cuu">Codice univoco</Trans>
                </Form.Label>
                <Form.Control
                  name="cuu"
                  placeholder={t('components.brands.cuu', 'Codice univoco')}
                  value={cuu ?? ''}
                  onChange={this.handleChange}
                  disabled={readonly}
                />
              </Form.Group>
            </Row>
            <div className="d-flex flex-column" style={{ height: '20rem' }}>
              <Form.Label>
                <Trans i18nKey="components.brands.references">Referenti</Trans>
                {readonly === false && (
                  <Button size="sm" onClick={this.addNewReference} className="ms-2">
                    <i className="fas fa-plus fa-fw text-start me-0" />
                    <Trans i18nKey="buttons.add">Aggiungi</Trans>
                  </Button>
                )}
              </Form.Label>

              <ResponsiveTable
                ref={this.tableReferenceRef}
                className="flex-fill"
                data={references}
                totalRecords={references.length}
                columns={this.getColumns()}
                disableMediaQuery={true}
                showMenu={current_reference !== null}
                modalSize="md"
                menuContent={ReferenceForm}
                hideStatusBar={true}
                menuContentProps={{
                  title: current_reference
                    ? t('components.brands.edit_reference', 'Modifica referente')
                    : t('components.brands.add_reference', 'Aggiungi referente'),
                  reference: current_reference,
                  onSave: this.onAddReference,
                  closeForm: () => {
                    this.setState({ current_reference: null })
                  },
                  forceUseModal: true,
                }}
              />
            </div>
          </div>
        </div>
        <div className="border-top pt-2">
          {readonly === false && (
            <Button
              className="float-end"
              variant="primary"
              disabled={!this.isFormValid() || this.initialHash === this.state.brand_hash}
              onClick={this.handleConfirm}>
              <Trans i18nKey="buttons.confirm">Conferma</Trans>
            </Button>
          )}

          <Button className="float-end me-2" variant="secondary" onClick={this.props.closeForm}>
            <Trans i18nKey="buttons.cancel">Annulla</Trans>
          </Button>
        </div>
      </>
    )
  }
}
export default BrandForm
